import styled from "styled-components";

interface IBillboardHighlightsContentContainerProps {
  selectedGroupsLength: number;
}

export const BillboardHighlightsContentContainer = styled.div<IBillboardHighlightsContentContainerProps>`
  height: 100%;
  padding: 2rem;
  position: relative;
  width: 100%;
  margin: 0 auto;

  @media (max-width: 600px) {
    padding: 1rem;
  }

  .billboard-highlights-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1.5rem;
    flex-direction: column;
    gap: 1rem;

    @media screen and (min-width: 768px) {
      flex-direction: row;
    }

    .title {
      display: flex;

      h1 {
        align-items: center;
        color: ${({ theme }) => theme.groups.primaryText};
        display: flex;
        font-family: "Inter";
        font-style: normal;
        font-weight: 600;
        font-size: max(1.2vw, 1.5rem);
        line-height: 150%;
        margin: 0;

        :first-child {
          opacity: 0.6;

          :hover {
            cursor: pointer;
          }
        }

        svg * {
          stroke: ${({ theme }) => theme.groups.primaryText} !important;
        }
      }
    }

    .btn-billboard-highlights {
      display: flex;
      gap: 0.5rem;

      button {
        align-items: center;
        background: ${({ theme }) =>
          theme.controlPanel.billboardBackgroundListItems};
        border-radius: 0.25rem;
        border: none;
        color: ${({ theme }) => theme.groups.secondaryText};
        font-family: "Inter";
        font-style: normal;
        font-weight: 600;
        font-size: max(0.6vw, 0.875rem);
        justify-content: center;
        padding: 0.5rem 1rem;
        line-height: 150%;
        opacity: 0.8;
        transition: all 100ms ease-in-out;

        :hover {
          cursor: pointer;
          opacity: 1;
        }
      }

      #submit {
        background: #236c33;
        color: #f2f2f2;
      }
    }
  }

  .billboard-highlights {
    align-items: flex-start;
    background: ${({ theme }) =>
      theme.controlPanel.billboardBackgroundListItems};
    border-radius: ${({ selectedGroupsLength }) =>
      selectedGroupsLength ? " 0.25rem 0.25rem 0 0" : "0.25rem"};
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding: 1.5rem;

    .header {
      align-items: center;
      display: flex;
      justify-content: space-between;
      width: 100%;
      flex-direction: column;
      gap: 1rem;

      @media screen and (min-width: 600px) {
        flex-direction: row;
      }

      div {
        h3 {
          align-items: center;
          color: ${({ theme }) => theme.groups.primaryText};
          display: flex;
          font-family: "Inter";
          font-style: normal;
          font-weight: 600;
          font-size: 1rem;
          line-height: 150%;
          margin: 0;
        }

        p {
          align-items: center;
          color: ${({ theme }) => theme.groups.secondaryText};
          display: flex;
          font-family: "Inter";
          font-style: normal;
          font-weight: 400;
          font-size: 0.875rem;
          line-height: 150%;
          margin: 0;
        }
      }
    }
  }

  .billboard-content-group-list {
    background: ${({ theme }) =>
      theme.controlPanel.billboardBackgroundListItems};
    border-radius: 0 0 0.25rem 0.25rem;

    ul li:last-child {
      padding-bottom: 1rem;
    }

    .empty-highlights {
      display: block;
      color: ${({ theme }) => theme.groups.secondaryText};
      font-family: "Inter";
      font-style: normal;
      font-weight: 400;
      font-size: 0.875rem;
      line-height: 150%;
      margin: 0;
      padding: 2rem 0;
      text-align: center;
      width: 100%;
    }

    .circular-loader {
      align-items: center;
      background: transparent;
      border-radius: 0.25rem;
      border: none;
      display: flex;
      flex-direction: row;
      gap: 0.5rem;
      justify-content: center;
      padding: 0.5rem 1rem;
      max-width: 56px;
      max-height: 40px;
      margin-top: 0;

      svg {
        height: 1.5rem;
        z-index: 1 !important;
        width: 1.5rem;
      }

      .loader {
        color: #f2f2f2;
      }

      :hover {
        cursor: pointer;
      }
    }
  }

  .billboard-content-group-list-item {
    align-items: center;
    display: flex;
    padding: 0.25rem 1.5rem;

    > div {
      align-items: center;
      display: flex;
      gap: 1rem;
      width: 100%;

      p {
        align-items: center;
        display: flex;
        font-family: "Inter";
        font-style: normal;
        font-weight: 700;
        font-size: 0.875rem;
        line-height: 150%;
        margin: 0;
      }
    }

    .remove-selected-group,
    .circular-loader {
      align-items: center;
      background: ${({ theme }) =>
        theme.controlPanel.billboardBackgroundButtonConfig};
      border-radius: 0.25rem;
      border: none;
      display: flex;
      flex-direction: row;
      gap: 0.5rem;
      justify-content: center;
      padding: 0.5rem 1rem;
      max-width: 56px;
      max-height: 40px;
      margin-top: 0;

      svg {
        z-index: 1 !important;
      }

      :hover {
        cursor: pointer;
      }
    }
  }
`;
